import React from 'react';
import {useAppSelector} from '../store/hooks';
import {needsVideoEditorSelector} from '../store/selectors/auth.selectors';
import {useVideoEditorPreference} from './useVideoEditorPreference';
import VideoEditorGateModal from './VideoEditorGateModal';

/**
 * Mounted once in `AppLayout` (see `App.tsx`) so the gate sits in front of every signed-in page.
 * `needsVideoEditorSelector` alone decides whether it's open — there is no local dismiss state,
 * because the whole point of this gate is that closing it and answering it are the same action.
 */
const VideoEditorGateContainer: React.FC = () => {
  const needsVideoEditor = useAppSelector(needsVideoEditorSelector);
  const videoEditorPreference = useVideoEditorPreference();

  return (
    <VideoEditorGateModal
      isOpen={needsVideoEditor}
      videoEditor={videoEditorPreference.videoEditor}
      onSelect={videoEditorPreference.choose}
      isSaving={videoEditorPreference.isSaving}
    />
  );
};

export default VideoEditorGateContainer;
